import AWS from 'aws-sdk';

const configureS3Client = () => {
  AWS.config.update({
    region: process.env.REACT_APP_AWS_REGION,
    accessKeyId: process.env.REACT_APP_ACCESSKEYID_AWS,
    secretAccessKey: process.env.REACT_APP_ACCESSKEYSECRET_AWS,
  });
  return new AWS.S3();
};

const pad2 = (n) => String(n).padStart(2, '0');

const joinPrefix = (base, yyyy, mm, dd) => {
  const normalized = (base || '').replace(/^\/*/, '').replace(/\/*$/, '');
  const parts = [normalized, yyyy, mm, dd].filter(Boolean);
  return parts.join('/') + '/';
};

// Lista objetos por datas decrescentes (hoje -> passado), coletando até `limit` itens.
// startOffsetDays permite paginar para dias anteriores (0 = hoje, 1 = ontem, etc.)
export const awsListByDates = async ({ limit = 50, startOffsetDays = 0, maxDaysToScan = 60 } = {}) => {
  const s3 = configureS3Client();
  const bucket = process.env.REACT_APP_AWS_BUCKET;
  const basePrefix = process.env.REACT_APP_AWS_PREFIX;

  const items = [];
  let offset = startOffsetDays;
  const now = new Date();

  const listTopRecentOfDay = async (prefix, topLimit) => {
    let marker;
    let isTruncated = true;
    let top = [];
    while (isTruncated) {
      // eslint-disable-next-line no-await-in-loop
      const resp = await s3
        .listObjects({ Bucket: bucket, Prefix: prefix, MaxKeys: 1000, ...(marker ? { Marker: marker } : {}) })
        .promise();
      const contents = Array.isArray(resp.Contents) ? resp.Contents : [];
      if (contents.length > 0) {
        top = [...top, ...contents]
          .sort((a, b) => new Date(b.LastModified).getTime() - new Date(a.LastModified).getTime())
          .slice(0, topLimit);
        marker = contents.slice(-1)[0]?.Key;
      }
      isTruncated = Boolean(resp.IsTruncated);
      if (!isTruncated) break;
    }
    return top;
  };

  while (items.length < limit && offset < startOffsetDays + maxDaysToScan) {
    const d = new Date(now.getTime() - offset * 24 * 60 * 60 * 1000);
    // Usar UTC para montar o prefixo, alinhando com a estrutura previamente utilizada
    const yyyy = d.getUTCFullYear();
    const mm = pad2(d.getUTCMonth() + 1);
    const dd = pad2(d.getUTCDate());
    const prefix = joinPrefix(basePrefix, yyyy, mm, dd);

    if (offset === startOffsetDays) {
      // Para o dia atual, varremos o prefixo e mantemos apenas os 'limit' itens mais recentes por LastModified
      // eslint-disable-next-line no-await-in-loop
      const top = await listTopRecentOfDay(prefix, limit);
      if (top.length > 0) items.push(...top);
    } else {
      // Para dias anteriores, uma única listagem é suficiente para completar até o limite global
      // eslint-disable-next-line no-await-in-loop
      const resp = await s3
        .listObjects({ Bucket: bucket, Prefix: prefix, MaxKeys: Math.max(limit - items.length, 0) })
        .promise();
      if (Array.isArray(resp.Contents) && resp.Contents.length > 0) {
        items.push(...resp.Contents);
      }
    }
    offset += 1; // próximo dia anterior
  }

  return {
    items,
    nextDateOffset: offset, // onde continuar na próxima chamada
  };
};

export default awsListByDates;


